import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import registerServiceWorker from './registerServiceWorker'

import 'bootstrap-sass/assets/stylesheets/_bootstrap.scss'
import 'react-select/dist/react-select.css'

import './styles/index.scss'

ReactDOM.render(<App />, document.getElementById('root'))
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js